import React from 'react'
import { useState, useEffect } from 'react';
import { make_readable_date } from '../../js functions/chartCompute.js';
import { get_data_of_exercise } from '../../js functions/LDBfunctions';
import Counter from './master/counter.js';
import Line_chart from './master/Line_chart.js';

function RepCount({ dateRangeEnd, dateRangeStart, ActiveExcercise }) {

    const [RepCountData, setRepCountData] = useState([]);
    const [slope, setSlope] = useState(0);
    const heading = "New Rep Count";
    const Yaxis_name = "Reps Count ";


    useEffect(() => {
        compute_RepCount(dateRangeStart, dateRangeEnd, ActiveExcercise);
    }, []);


    async function compute_RepCount(dateRangeStart, dateRangeEnd, ActiveExcercise) {

        try {




            const data = await get_data_of_exercise(dateRangeStart, dateRangeEnd, ActiveExcercise); // array between from and to dates of specific exercise

            // Check if data is undefined or empty
            if (!data || data.length === 0) {
                console.log('No data available for the selected exercise and date range');
                setRepCountData([]);
                setSlope(0);

            } else {


                const chartData = [];

                data.forEach((record) => {
                    let totalReps = 0;

                    const sets = record.sets;

                    sets.forEach((set) => {
                        totalReps += set.reps;
                    });

                    chartData.push({
                        y: totalReps,
                        x: make_readable_date(record.start_time),
                    });
                });

                setRepCountData(chartData);



            }







        } catch (err) {
            console.log(err);
        }

    }






    return (
        <div className='chart-card-container'>
            <h4>{heading}</h4>

            <div className="chart-card">


                <div className='summary-box' >



                    <div className='counter-box' >

                        <Counter counterData={slope} heading={"Slope"} />

                        <Counter />

                    </div>


                    <p> Great job! Your total volume for incline dumbbell press has increased by 15% over the last month. This shows your chest and upper body strength are improving steadily. Keep it up!  </p>
                </div>



                <Line_chart data={RepCountData} Yaxis_name={Yaxis_name} />



            </div>


        </div>
    )
}

export default RepCount